<template>
  <div class="on-reject">
    <v-dialog v-model="isOnRejectDialogVisible" persistent width="720px">
      <v-card>
        <v-card-title class="amber"
          ><span class="headline"
            >Reject - {{ caseObject.UniqueIdentifier }}</span
          ></v-card-title
        >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-row>
                <v-col sm="6">
                  <v-select
                    :items="onRejectReasons"
                    v-model="onRejectReason"
                    :rules="onRejectReasonRules"
                    required
                    label="Select reject reason(s)"
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip x-small v-if="index === 0">
                        <span>{{ item }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">
                        (+{{ onRejectReason.length - 1 }} more)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col sm="12">
                  <v-textarea
                    label="Reject Case Notes"
                    v-model="onRejectCaseNotes"
                    rows="3"
                  ></v-textarea>
                </v-col>
                <v-col sm="6">
                  <v-select
                    :items="poorScanReasons"
                    v-model="poorScanReason"
                    label="Select poor scan reason(s)"
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip x-small v-if="index === 0">
                        <span>{{ item }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">
                        (+{{ poorScanReason.length - 1 }} more)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col sm="6">
                  <v-select
                    :items="rightFirstTimeCodes"
                    v-model="rightFirstTime"
                    label="Select right first time code(s)"
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip x-small v-if="index === 0">
                        <span>{{ item }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption" s>
                        (+{{ rightFirstTime.length - 1 }} more)
                      </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn text @click="onCancel">Cancel</v-btn>
          <v-btn text color="warning" :disabled="!valid" @click="onReject"
            >Reject</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "on-reject",
  props: {
    showOnRejectDialog: {
      type: Boolean,
      default: false,
    },
    caseObject: {
      type: Object,
      require: false,
    },
  },
  data() {
    return {
      valid: false,
      onRejectReason: "",
      onRejectReasonRules: [(v) => !!v || "Reject reason is required"],
      onRejectCaseNotes: "",
      poorScanReason: "",
      rightFirstTime: "",
    };
  },
  computed: {
    ...mapGetters("accounts", { currentAccount: "getCurrentAccount" }),
    isOnRejectDialogVisible: {
      get() {
        return this.showOnRejectDialog;
      },
      set(value) {
        this.$emit("on-reject-dialog-state-change", value);
      },
    },
    pScore() {
      if (this.caseObject.isUrgent) {
        return `0_${this.$moment(this.caseObject.needDate).format(
          "YYYYMMDD"
        )}_${this.$moment(this.caseObject.shareDate).format("YYYYMMDD")}`;
      } else {
        return `1_${this.$moment(this.caseObject.needDate).format(
          "YYYYMMDD"
        )}_${this.$moment(this.caseObject.shareDate).format("YYYYMMDD")}`;
      }
    },
    onRejectReasons() {
      if (this.caseObject.caseType === "TKA") {
        return [
          "Auto-reject",
          "Bilat in one exam",
          "Case canceled",
          "Case no longer available in LifeImage",
          "Clipped regions – hip/knee/ankle",
          "Confirmed revision",
          "DICOM naming- missing patient’s first/last name",
          "DICOM naming- missing two unique names",
          "DICOM naming- incorrect TPR naming convention",
          "DOB discrepancy",
          "Duplicate share by MPS team",
          "Existing TKA/PKA implant",
          "Failed motion check",
          "Field of view (FOV) violation",
          "File compression issue-voyager data error",
          "Image blur",
          "Incomplete MRN",
          "Incorrect operative side",
          "Insufficient length – femur",
          "Insufficient length – tibia",
          "Missing DOB (anonymized cases)",
          "Missing region – hip/knee/ankle",
          "No contrast/inverted contrast",
          "Open brace error",
          "Permission to download",
          "Scan broken up- fixed axial/different centers",
          "Scan broken up- missing/skipped slices",
          "Severely rotated ankle",
          "Slice increment/spacing – hip/knee/ankle",
          "THA protocol",
          "Unmatched reference frame",
        ];
      } else {
        return [
          "Case canceled",
          "Case no longer in LifeImage",
          "Clipped regions",
          "Confirmed revision",
          "DICOM naming- carets",
          "DICOM naming- special characters",
          "DICOM naming- upper/lower case",
          "DICOM naming- missing patient’s first/last name",
          "DICOM naming- missing two unique names",
          "DICOM naming- incorrect TPR naming convention",
          "DOB discrepancy",
          "Duplicate share by MPS team",
          "Field of view (FOV) violation",
          "File compression issue-voyager data error",
          "Image blur",
          "Incomplete MRN",
          "Incorrect operative side",
          "Lesser trochanters missing/clipped",
          "Missing DOB (anonymized cases)",
          "Missing region – hip/knee",
          "No contrast/inverted contrast",
          "Noise/scatter – regions of interest not visible",
          "Open brace error",
          "Permission to download",
          "Resolution matrix less than 512x512 or not square",
          "Scan broken up- fixed axial/different centers",
          "Scan broken up- missing/skipped slices",
          "Slice thickness/spacing",
          "TKA protocol",
          "Uni-scan",
          "Unmatched reference frame",
          "Metal-on-Metal - no cup/mask division",
          "Poly Cup",
          "Extensive Hardware - obscures pelvic registration",
          "[Well-fixed Cups]",
        ];
      }
    },
    poorScanReasons() {
      if (this.caseObject.caseType === "TKA") {
        return [
          "Incorrect number of files",
          "Need by date change",
          "Noise/Scatter",
          "Resolution matrix greater than 512x512",
          "Reverted to legacy -case not in TDA",
          "Reverted to legacy -case rejected in TDA",
          "Rotated ankle",
          "Side switch",
        ];
      } else {
        return [
          "Bent/rotated leg",
          "Incorrect number of files",
          "Need by date change",
          "Noise/Scatter",
          "Resolution matrix greater than 512x512",
          "Reverted to legacy -case not in TDA",
          "Reverted to legacy -case rejected in TDA",
          "Side switch",
        ];
      }
    },
    rightFirstTimeCodes() {
      if (
        this.caseObject.caseType === "TKA" &&
        this.caseObject.isTDA === false
      ) {
        return [
          "[DR] False acceptance/rejection",
          "[DR] Incorrect information on router/TPR",
          "[DR] Incorrect patient downloaded",
          "[DR] Not submitted for high-risk evaluation",
          "[DR] Work not saved – no files (UTT)",
          "[PR] False acceptance/rejection",
          "[PR] Incomplete session file exported",
          "[PR] Incorrect patient attachment",
          "[PR] Not submitted for high-risk evaluation",
          "[PR] Plan not attached",
          "[PR] Poor quality",
          "[PR] Work not saved – no files (UTT)",
        ];
      } else if (
        (this.caseObject.caseType === "THA" ||
          this.caseObject.caseType === "Cadaver") &&
        this.caseObject.isTDA === false
      ) {
        return [
          "[DR] False acceptance/rejection",
          "[DR] Incorrect information on router/TPR",
          "[DR] Incorrect patient downloaded",
          "[DR] Incorrect series selected",
          "[DR] Not submitted for high-risk evaluation",
          "[DR] Work not saved – no files (UTT)",
          "[IS] False acceptance/rejection",
          "[IS] Model(s) labeled incorrectly",
          "[IS] Not submitted for high-risk evaluation",
          "[IS] Over/under segmentation",
          "[IS] Threshold not set to minimum",
          "[IS] Work not saved – no files (UTT)",
          "[FS] False acceptance/rejection",
          "[FS] Improper hemi-cut",
          "[FS] Not submitted for high-risk evaluation",
          "[FS] Over/under segmentation",
          "[FS] STLs labeled incorrectly",
          "[FS] Work not saved – no files (UTT)",
          "[PR] Incomplete session file exported",
          "[PR] Incorrect patient attachment",
          "[PR] Poor quality",
          "[PR] Work not saved – no files (UTT)",
        ];
      } else {
        return [
          "[DR] False acceptance/rejection",
          "[DR] Incorrect information on router/TPR",
          "[DR] Incorrect series selected",
          "[DR] Not submitted for high-risk evaluation",
          "[IS] False acceptance/rejection",
          "[IS] Not submitted for high-risk evaluation",
          "[IS] Over/under segmentation",
          "[FS] False acceptance/rejection",
          "[FS] Improper hemi-cut/Short models",
          "[FS] Not submitted for high-risk evaluation",
          "[FS] Over/under segmentation",
          "[PR] Incomplete session file exported",
          "[PR] Incorrect patient attachment",
          "[PR] Plan not attached",
          "[PR] Poor quality",
          "[PR] Work not saved – no files (UTT)",
        ];
      }
    },
  },
  methods: {
    ...mapActions("cases", { updateCase: "updateCase" }),
    onCancel() {
      this.$refs.form.reset();
      this.isOnRejectDialogVisible = false;
    },
    async onReject() {
      this.caseObject["pScore"] = this.pScore;
      this.caseObject["onRejectReason"] = this.onRejectReason;
      this.caseObject["onRejectCaseNotes"] = this.onRejectReason.concat(
        this.onRejectCaseNotes
      );
      this.caseObject["poorScanReason"] = this.poorScanReason;
      this.caseObject["rightFirstTime"] = this.rightFirstTime;
      this.caseObject["currentlyAssignedRep"] = "";
      this.caseObject["isReject"] = true;
      this.caseObject["segRegion"] = this.currentAccount.region;
      this.caseObject["dataReview"] = {
        repEmail: this.currentAccount.email,
        timeStamp: this.$moment().utc(),
      };
      this.caseObject[
        "updatedBy"
      ] = this.$store.state.accounts.account.username;
      this.caseObject["updatedDate"] = this.$moment().utc();
      if (this.caseObject.caseStatus.includes("Data Review")) {
        this.caseObject["caseStatus"] = "Rejected - Data Review";
      }
      if (this.caseObject.caseStatus.includes("Initial Segmentation")) {
        this.caseObject["caseStatus"] = "Rejected - Initial Segmentation";
      }
      if (this.caseObject.caseStatus.includes("Segmentation Review")) {
        this.caseObject["caseStatus"] = "Rejected - Segmentation Review";
      }
      if (this.caseObject.caseStatus.includes("Plan Review & Upload")) {
        this.caseObject["caseStatus"] = "Rejected - Plan Review & Upload";
      }
      console.log(this.caseObject);
      await this.$http.post(
        "https://prod-62.eastus2.logic.azure.com:443/workflows/d5ce54f34a8c42a2a5a86443ad54fef9/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=TU9fufz3BpeHGMsxNsMCH2LB_XivUEZSKL5iyxtfWGE",
        this.caseObject
      );
      await this.updateCase(this.caseObject);
      this.$router.push({ name: "Tasks" });
      // this.$refs.form.reset();
      // this.isOnRejectDialogVisible = false;
    },
  },
  watch: {
    onRejectReason: function(newValue, oldValue) {
      console.log("On-hold reason changed: ", {
        newValue: newValue,
        oldValue: oldValue,
      });
    },
  },
};
</script>

<style></style>
